export const AUTH_SERVICE = "AuthService";
